export const QA_GET_USERLISTACCORDINGROLE_LISTING =
  "QA_GET_USERLISTACCORDINGROLE_LISTING"
export const QA_GET_USERLISTACCORDINGROLE_LISTING_SUCCESS =
  "QA_GET_USERLISTACCORDINGROLE_LISTING_SUCCESS"
export const QA_GET_USERLISTACCORDINGROLE_LISTING_FAILED =
  "QA_GET_USERLISTACCORDINGROLE_LISTING_FAILED"
